<div
	#contentWrapper
	*ngIf="seoContent"
	class="content-wrapper"
	[ngClass]="{'expanded': !isContentCollapsed, 'has-overflow': isContentCollapsed && hasOverflow, 'transition-disabled': isTransitionDisabled}"
	obgResizeObserver
	(resize)="onResize()"
>
	<h1 class="title" *ngIf="seoContent.h1Title" test-id="seo-contentTitleH1">{{ seoContent.h1Title }}</h1>
	<obg-seo-proposition-messages *ngIf="!isDesktop"></obg-seo-proposition-messages>
	<textarea class="seo-proxy" #escapedText [innerHtml]="seoContent?.seoText"> </textarea>
	<div
		*ngIf="escapedText?.value"
		class="seo-content"
		[innerHTML]="escapedText?.value"
		test-id="seo-contentTextH1"
	></div>
	<div *ngIf="!escapedText?.value" test-id="alternate-seo">
		<h2 class="title" *ngIf="seoContent.h2Title" test-id="seo-contentTitleH2">{{ seoContent.h2Title }}</h2>
		<div
			class="seo-text-content"
			*ngIf="seoContent.h2Text"
			[innerHTML]="seoContent.h2Text"
			test-id="seo-contentTextH2"
		></div>
		<h3 class="title" *ngIf="seoContent.h3Title" test-id="seo-contentTitleH3">{{ seoContent.h3Title }}</h3>
		<div
			class="seo-text-content"
			*ngIf="seoContent.h3Text"
			[innerHTML]="seoContent.h3Text"
			test-id="seo-contentTextH3"
		></div>
	</div>
</div>
<a
	*ngIf="seoContent && (hasOverflow || !isContentCollapsed || isBot)"
	class="toggle-collapse-button"
	(click)="toggleCollapseContent()"
	test-id="show-more-less-button"
	>{{ (isContentCollapsed ? "general.show-more" : "general.show-less") | translate }}
</a>
